<template>
    <div class="allCallLogBox">
        <div style="display: flex">
            <el-form ref="listArgument" :model="listArgument">
                <el-form-item prop="phone">
                    <el-input v-model="listArgument.phone" placeholder="请输入被叫号码"></el-input>
                </el-form-item>
                <el-form-item v-if="user_type==2" prop="zuoxi_mobile">
                    <el-select
                        v-model="listArgument.zuoxi_mobile"
                        class="filter-item common-r"
                        placeholder="请选择坐席"
                    >
                        <el-option
                            v-for="item in seatsList"
                            :key="item.mobile"
                            :label="item.name"
                            :value="item.mobile">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="searchBox">
                <el-button type="primary" @click="searchBtn">搜索</el-button>
                <el-button @click="clearBtn">清空</el-button>
            </div>
        </div>
        <avue-crud :data="data"  ref="crud" :option="option"
                   @size-change="sizeChange" :page.sync="page" @current-change="currentChange">
            <template slot-scope="scope" slot="record_url">
                <span v-if="scope.row.duration1==0 && scope.row.duration!==0">录音文件生成中...</span>
                <audio :src="scope.row.record_url" controls
                       v-if="scope.row.duration!==0"
                       @canplay="(e) => getDuration(e, scope.row)"></audio>
            </template>
        </avue-crud>
    </div>
</template>

<script>
import { allCallRecord, getSeatsList } from '@/api/callCenter';

export default {
    name: "allCallLog",
    data() {
        return {
            listArgument:{
                phone:'',
                zuoxi_mobile:'',
                limit:10,
                page:1
            },
            page:{
                currentPage: 1,
                total: 20,  //总数
                pageSize: 10
            },
            user_type:'',
            seatsList:[],
            data: [],
            option: {
                stripe: true,
                // index:true,
                searchMenuSpan: 3,
                indexLabel: '序号',  //添加序号
                selection: false, //批量选择
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menuWidth: 150,  //操作栏宽度设置
                menuType: 'menu',
                menu:false,
                menuBtnTitle: '操作',
                column: [
                    {
                        label: '通话记录ID',
                        prop: 'id'
                    },
                    {
                        label: '坐席号',
                        prop: 'mobile'
                    },
                    {
                        label: '被叫号码',
                        prop: 'tel_b'
                    },
                    {
                        label: '通话接通时间',
                        prop: 'start'
                    },
                    {
                        label: '通话结束时间',
                        prop: 'end'
                    },
                    {
                        label: '通话时长（秒）',
                        prop: 'duration'
                    },
                    {
                        label: '录音',
                        prop: 'record_url',
                        width: '350'
                    },
                ]
            }
        }
    },
    methods:{
        getDuration(e, row) {
            row.duration1 = e.target.duration; // 将时长存储到当前行数据
        },
        // 分页
        currentChange(num){
            this.listArgument.page = num;
            allCallRecord(this.listArgument).then(res=>{
                this.data = res.data.list.map(item => {
                    // 添加已有数据匹配
                    const existing = this.data.find(d => d.id === item.id);
                    return {
                        ...item,
                        duration1: existing ? existing.duration1 : 0
                    }
                })
                this.page.total = res.data.count;
            })
            sessionStorage.setItem('allCallLog', num);
        },
        // 切换每一页条数
        sizeChange(val){
            this.listArgument.page = 1;
            this.listArgument.limit = val;
            sessionStorage.removeItem('allCallLog')
            this.getList()
        },
        // 搜索
        searchBtn(){
            this.listArgument.page = 1;
            this.getList();
        },
        // 清空
        clearBtn(){
            this.listArgument.page = 1;
            this.listArgument.limit = 10;
            sessionStorage.removeItem('allCallLog')
            this.getList()
            this.$refs.listArgument.resetFields();
        },
        getList() {
            let num = Number(sessionStorage.getItem('allCallLog'));
            allCallRecord(this.listArgument).then(res => {
                if (res.code == 200) {
                    // 保留已有的 duration1 值
                    this.data = res.data.list.map(item => {
                        const existingItem = this.data.find(d => d.id === item.id);
                        return {
                            ...item,
                            duration1: existingItem ? existingItem.duration1 : 0 // 保留已有的 duration1 值
                        };
                    });
                    this.page.total = res.data.count;
                    this.page.currentPage = (this.page.currentPage && num !== 0) ? num : 1;
                } else {
                    this.$message.error(res.msg);
                }
            });
        }

    },
    created() {
        this.user_type=JSON.parse(sessionStorage.getItem('shenfen')).user_type;
        let num = Number(sessionStorage.getItem('allCallLog'));
        if (num==0) {
            this.getList();
        }else {
            this.listArgument.page = num;
            allCallRecord(this.listArgument).then(res=>{
                this.data = res.data.list.map(item => {
                    // 添加已有数据匹配
                    const existing = this.data.find(d => d.id === item.id);
                    return {
                        ...item,
                        duration1: existing ? existing.duration1 : 0
                    }
                })
                this.page.total = res.data.count;
                this.page.currentPage = num;
            })
        }
        getSeatsList().then(res=>{
            if (res.code==200){
                this.seatsList=res.data.list;
            }else{
                this.$message.error(res.msg);
            }
        })
    }
}
</script>

<style scoped lang="scss">
    .allCallLogBox{
        padding: 20px;
        background-color: #ffffff;
        border-radius: 5px;
    }
    .el-form{
        display: flex;
    }
    .el-form-item{
        margin-right: 10px;
    }
    .pull-down{
        padding: 10px 30px;
    }
    ::v-deep .avue-crud__menu{
        min-height: 0px;
    }
</style>